define('utils/js-log',[],function() {
    window.onerror = function(e, url, line) {
        if (typeof localStorage != 'undefined') {
            var error = {
                    'time' : new Date().getTime(),
                    'error' : url + '(line ' + line + ') have error : ' + e
            };
            var json = {
                    'errors' : []
            };
            if ('jsError' in localStorage) {
                json = JSON.parse(localStorage.getItem('jsError'));
            }
            json.errors.push(error);
            localStorage.setItem('jsError', JSON.stringify(json));
        } else {
            console.log('localStorage n est pas supportée');
        }
        return true;
    };
});

